import { useEffect, useState } from "react";

export function useScrollIsOnTop(threshold = 30) {
    const [isAtTop, setIsAtTop] = useState(true);

    useEffect(
        function updateIsOnTopBasedOnScrollPosition() {
            function handleScroll() {
                setIsAtTop(window.scrollY < threshold);
            }

            window.addEventListener("scroll", handleScroll, { passive: true });

            handleScroll();

            return () => window.removeEventListener("scroll", handleScroll);
        },
        [threshold],
    );

    return isAtTop;
}
